import EmailJs from '@emailjs/browser'
EmailJs.init("O9QAvuIE7-wCK_aG9")
export default{
    sendEmail(recipient_name,recipient_email,event_title,event_pass_link) {
        var templateParams = {
            to_name: recipient_name,
            user_email:recipient_email,
            event_title: event_title,
            event_pass_link:event_pass_link
        };

        EmailJs.send("service_lp3x0i9", "template_efhkmv8", templateParams).then(response => {
            console.log('SUCCESS!', response.status, response.text);
        }).catch(err => {
            console.log('FAILED...', err);
        })

    }
}